import React, { useEffect, useState } from "react";

import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { FaClipboardList } from "react-icons/fa";

import URL from "../../config/api";
import axios from "../../config/axios";
import { FORMULARIOS_PATH } from "../../config/formularios";
import "./formulario.css";

/* Aviso ao aluno, logo depois de entrar, de que há formulários agendados que
   ele ainda não respondeu.

   Aparece uma vez por login, e não a cada página nem a cada F5: a marca fica
   no localStorage, amarrada ao token da sessão. Novo login traz outro token e
   o aviso volta, se ainda houver pendência. Sem localStorage (aba anônima,
   armazenamento bloqueado), o pior caso é o aviso reaparecer ao recarregar.

   O layout/Main.js só monta este componente depois do modal de primeiro acesso
   e do card de emoções, para não empilhar modais. */

const CHAVE = "formularios-aviso-login";
const MAX_TITULOS = 3;

const jaAvisado = token => {
  try {
    return window.localStorage.getItem(CHAVE) === token;
  } catch (_erro) {
    return false;
  }
};

const marcarAvisado = token => {
  try {
    window.localStorage.setItem(CHAVE, token);
  } catch (_erro) {
    // Sem armazenamento, o aviso pode voltar ao recarregar; não impede nada.
  }
};

export const formulariosPendentes = assigned =>
  (Array.isArray(assigned) ? assigned : []).filter(item => !item.respondido);

export default function AvisoFormulariosPendentes({ token, history }) {
  const [pendentes, setPendentes] = useState([]);
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    if (!token || jaAvisado(token)) return undefined;
    let ativo = true;

    axios
      .get(`${URL.api}formulario/assigned`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resposta => {
        if (!ativo) return;
        const lista = formulariosPendentes(resposta.data?.data);
        // Sem pendência não marca: se o professor agendar um formulário
        // durante a sessão, o próximo login ainda avisa.
        if (!lista.length) return;
        marcarAvisado(token);
        setPendentes(lista);
        setAberto(true);
      })
      .catch(() => {
        // Módulo desligado para o grupo (403/404) ou falha de rede: o aviso é
        // um lembrete, e não vale um erro na cara do aluno ao entrar.
      });

    return () => {
      ativo = false;
    };
  }, [token]);

  if (!aberto) return null;

  const fechar = () => setAberto(false);
  const total = pendentes.length;

  return (
    <CModal
      show={aberto}
      onClose={fechar}
      centered
      className="formulario-aviso-modal"
    >
      <CModalHeader closeButton>
        <CModalTitle>
          {total === 1
            ? "Você tem um formulário para responder"
            : "Você tem formulários para responder"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className="formulario-aviso">
          <span className="formulario-aviso__icone" aria-hidden="true">
            <FaClipboardList />
          </span>
          <div>
            <p>
              {total === 1
                ? "Há 1 formulário disponível para você."
                : `Há ${total} formulários disponíveis para você.`}
            </p>
            <ul className="formulario-aviso__lista">
              {pendentes.slice(0, MAX_TITULOS).map(item => (
                <li key={item.id}>{item.formulario?.titulo}</li>
              ))}
              {total > MAX_TITULOS && (
                <li className="formulario-aviso__mais">
                  e mais {total - MAX_TITULOS}
                </li>
              )}
            </ul>
          </div>
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" variant="outline" onClick={fechar}>
          Agora não
        </CButton>
        <CButton
          color="primary"
          onClick={() => {
            fechar();
            history.push(FORMULARIOS_PATH);
          }}
        >
          Ver formulários
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
